import styled, { css } from 'styled-components';
import { hexToRGB } from '@/styles/helpers';

interface IScArrowButtonProps {
  isOpen: boolean;
}

export const ScArrowButton = styled.div<IScArrowButtonProps>`
  display: flex;
  gap: 8px;
  font-size: 14px;
  line-height: 20px;
  justify-content: center;
  margin: 0 auto;
  align-items: center;
  padding: 12px;
  cursor: pointer;
  color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
  & .arrow-icon {
    display: flex;
    transition: transform 200ms ease;
    transform: rotate(${({ isOpen }) => (isOpen ? '-180deg' : '0deg')});
    ${({ isOpen }) =>
      isOpen &&
      css`
        i {
          color: ${({ theme }) => theme.whiteColor};
        }
      `}
  }
`;
